import React, { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { baseURL, getCategories, logoutUser } from "../redux/Action";

// v1 imports
import BlogForm from "../Components/v1/BlogForm";
import { FEATURED_IMAGE } from "../Public/constants";

const CreateBlogs = () => {
  const { isAuth, categories, token } = useSelector((state) => state);
  const [formData, setFormdata] = useState({});
  const [featuredImage, setFeaturedImage] = useState(null);
  const [formCheckbox, setFormCheckbox] = useState({});
  const [content, setContent] = useState("");

  const navigate = useNavigate();
  const notify = (msg) => toast(msg, { theme: "dark" });
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Blogshog | Create Blog";
    getCategories(dispatch);
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata({
      ...formData,
      [name]: value,
    });
  };

  const handleCheckbox = (e) => {
    let { name, value, type, checked } = e.target;
    value = type === "checkbox" ? checked : value;
    setFormCheckbox({
      ...formCheckbox,
      [name]: value,
    });
  };

  const submitBlog = (e) => {
    e.preventDefault();
    const categories_array = [];
    for (let x in formCheckbox) {
      if (formCheckbox[x] === true) {
        categories_array.push(x);
      }
    }
    const payload = {
      ...formData,
      body: content,
      categories_array,
      featuredImage: featuredImage || FEATURED_IMAGE,
    };

    if (categories_array.length === 0) {
      return notify("Please choose one or more categories");
    }
    if (content.trim().length === 0 || content === "<p><br></p>") {
      return notify("Please write some description");
    }

    const toastId = toast.loading("Creating Blog...", { theme: "dark" });
    axios
      .post(`${baseURL}/blogs`, payload, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.update(toastId, {
          render: "Blog created Successfully",
          type: "success",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
        navigate("/blogs");
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message === "No token provided.") {
          navigate("/login");
        }
        if (err) {
          toast.update(toastId, {
            render: "Something went wrong",
            type: "error",
            isLoading: false,
            autoClose: 2000,
            closeOnClick: true,
          });
        }
        if (err.response.status === 401) {
          toast.update(toastId, {
            render: "Session Expired. Please Login Again",
            type: "error",
            isLoading: false,
            autoClose: 2000,
            closeOnClick: true,
          });
          logoutUser(dispatch);
        }
      });
  };

  if (!isAuth) {
    return <Navigate to={"/login"} />;
  }

  return (
    <div className="min-h-screen bg-gray-50/50 dark:bg-transparent pb-24">
      <form onSubmit={submitBlog}>
        <BlogForm
          handleChange={handleChange}
          content={content}
          setContent={setContent}
          handleCheckbox={handleCheckbox}
          categories={categories}
          setFeaturedImage={setFeaturedImage}
        />
      </form>
    </div>
  );
};

export default CreateBlogs;
